import * as dateFns from "../../date-fns/index.js";
window.dateFns = {
  ...window.dateFns,
  ...dateFns
};